<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>打卡景点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="sightsName" label="景点名称" width="150">
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="sightsIntro" label="景点简介" width="150">
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="sightsDetail" label="景点介绍" width="150">
      </el-table-column>
      <el-table-column prop="sightsLocation" label="景点坐标" width="150">
      </el-table-column>
      <el-table-column prop="drawLocation" label="手绘图坐标" width="150">
      </el-table-column>
      
      <el-table-column prop="sightsTypeId" label="景点类型" width="150">
      </el-table-column>
      <el-table-column prop="sightsSvg" label="svg" width="70">
        <template slot-scope="scope">
      <img :src="scope.row.sightsSvg" min-width="70" height="70"/>
    </template>
      </el-table-column>
      <el-table-column prop="audio" show-overflow-tooltip label="音频" width="70">
      </el-table-column>
      <el-table-column prop="sightsCoverSrc" label="景点封面图" width="70">
        <template slot-scope="scope">
      <img :src="scope.row.sightsCoverSrc" min-width="70" height="70"/>
    </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="sightsSrcList" label="景点图片列表" width="300">
        
      </el-table-column>
  
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 审核界面 -->
    <el-dialog :title="title" :visible.sync="auditFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="auditForm" ref="auditForm">
        <el-form-item label="审核状态">
          <el-select v-model="auditForm.status" placeholder="请选择">
            <el-option label="审核失败" value='0'></el-option>
            <el-option label="审核通过" value='1'></el-option>
            <el-option label="审核中" value='2'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitAuditForm('editForm')">提交</el-button>
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="景点名称" prop="sightsName">
          <el-input size="small" v-model="editForm.sightsName" auto-complete="off" placeholder="请输入景点名称"></el-input>
        </el-form-item>
        <el-form-item label="景点简介" prop="sightsIntro">
          <el-input size="small" v-model="editForm.sightsIntro" auto-complete="off" placeholder="请输入景点简介"></el-input>
        </el-form-item>
        <el-form-item label="景点介绍" prop="sightsDetail">
          <el-input type="textarea" size="small" v-model="editForm.sightsDetail" auto-complete="off" placeholder="请输入景点介绍"></el-input>
        </el-form-item>
        <el-form-item label="景点坐标" prop="sightsLocation">
          <el-input size="small" v-model="editForm.sightsLocation" auto-complete="off" placeholder="请输入景点名称"></el-input>
        </el-form-item>
        <el-form-item label="手绘坐标" prop="drawLocation">
          <el-input size="small" v-model="editForm.drawLocation" auto-complete="off" placeholder="请输入景点名称"></el-input>
        </el-form-item>
        <el-form-item label="景点类型" prop="sightsTypeId">
          <el-input size="small" v-model="editForm.sightsTypeId" auto-complete="off" placeholder="请输入景点类型"></el-input>
        </el-form-item>
        
        <el-form-item label="svg链接" prop="sightsSvg">
          <el-upload
  class="avatar-uploader"
  action="/admin/scDetails/uploadOss"
  :show-file-list="false"
  :on-success="handleAvatarSuccess"
  :before-upload="beforeAvatarUpload">
  <img v-if="editForm.sightsSvg" :src="editForm.sightsSvg" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

          <!-- <el-input size="small" v-model="editForm.sightsSvg" auto-complete="off" placeholder="请输入景点类型"></el-input> -->
        </el-form-item>
        <el-form-item label="音频" prop="audio">
          <el-upload
  class="upload-demo"
  drag
  action="/admin/scDetails/uploadOss"
  :on-success="handleAvatarSuccessAudio"
  multiple>
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
</el-upload>
<audio v-if="editForm.audio" ref="audio" :src="editForm.audio" controls></audio>

          <!-- <el-input size="small" v-model="editForm.audio" auto-complete="off" placeholder="请输入环境描述"></el-input> -->
        </el-form-item>

        <el-form-item label="景点封面图" prop="sightsCoverSrc">
          <el-upload
  class="avatar-uploader"
  action="/admin/scDetails/uploadOss"
  :show-file-list="false"
  :on-success="beforeAvatarUploadsightsCoverSrc">
  <img v-if="editForm.sightsCoverSrc" :src="editForm.sightsCoverSrc" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

          <!-- <el-input size="small" v-model="editForm.sightsSvg" auto-complete="off" placeholder="请输入景点类型"></el-input> -->
        </el-form-item>
        <el-form-item label="景点图片列表" prop="sightsCoverSrc">
          <el-upload
  class="upload-demo"
  action="/admin/scDetails/uploadOss"
  :on-preview="handlePreview"
  :on-remove="handleRemove"
  :on-success="beforeAvatarUploadList"
  :file-list="fileList"
  list-type="picture">
  <el-button size="small" type="primary">点击上传</el-button>
  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
</el-upload>

          <!-- <el-input size="small" v-model="editForm.sightsSvg" auto-complete="off" placeholder="请输入景点类型"></el-input> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import { scDetailsList,scDetailsListSave,scDetailsListUp,scDetailsListDel } from '../../api/campsMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      fileList:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      auditFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        id: '',
        sightsSvg:'',
        sightsCoverSrc:'',
        audio:'',
        name: '',
        address: '',
        description:'',
        // token: localStorage.getItem('logintoken')
      },
      auditForm: {
        id: '',
        status:''
      },
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请输入景点名称', trigger: 'blur' }
        ],
        address: [{ required: true, message: '请输入景点地址', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    beforeAvatarUploadList(res, file) {
        this.fileList.push(res.msg)
        //alert(res.msg)
        console.log("熙熙====",this.fileList)
        this.editForm.sightsSrcList=this.fileList+""
      },
    handleAvatarSuccess(res, file) {
        this.editForm.sightsSvg = res.msg
      },
      handleAvatarSuccessAudio
      (res, file) {
        this.editForm.audio = res.msg
      },
      beforeAvatarUploadsightsCoverSrc
      (res, file) {
        this.editForm.sightsCoverSrc = res.msg
      },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       scDetailsList(this.pageparm)
        .then(res => {
          this.loading = false
          if (res.data.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示审核界面
    handleAudit: function(index, row) {
      this.auditFormVisible = true
      this.title = '审核'
      this.auditForm.id = row.id
      this.auditForm.status = (row.status).toString()
    },
    // 审核页面保存方法
    submitAuditForm(editData) {
        // console.log(this.editForm);
      // this.auditForm.status = parseInt(this.auditForm.status);
      campListAudit(this.auditForm)
        .then(res => {
          // console.log(res);
          this.auditFormVisible = false
          this.loading = false
          if (res.data.code == 200) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '审核成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('审核失败，请稍后再试！')
        })
    },
    //显示编辑界面
    handleEdit: function(index, row) {

      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm = row
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.address = ''
        this.editForm.description = ''
      }
    },
    
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // console.log(this.editForm);
          if(this.editForm.id!==null&&this.editForm.id!==''&&this.editForm.id!==''&&this.editForm.id!==undefined){
            scDetailsListUp(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })


          }else{
            scDetailsListSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          scDetailsListDel({id:row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.auditFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>





// WEBPACK FOOTER //
// src/views/scDetails/scDetails.vue